import { Suspense } from "react"
import { ErrorBoundary } from "react-error-boundary"
import { RefreshPageFallback } from "@/components/refresh-page-fallback"
import { ChatResizableLayout } from "@/modules/chats/components/chat-layout/chat-resizable-layout"
import { ChatsAvailabilityBanner } from "@/modules/chats/components/chat-layout/chats-availability-banner"
import { ChatProvider } from "@/modules/chats/providers/chat-provider"
import { ProgressNoteFormProvider } from "@/modules/patients/detail/progress-note/hooks/useProgressNoteFormStore"
import { PreventionProgramsProvider } from "@/modules/patients/detail/store/usePreventionProgramsStore"
import { Notes } from "@/modules/temporary-notes/notes.tsx"
import useCallContextStore from "@/stores/useCallContextStore"

const IBCNotes = () => {
  const callId = useCallContextStore((state) => state.callID)
  return callId ? <Notes /> : null
}

export const Chats = () => {
  return (
    <ErrorBoundary FallbackComponent={RefreshPageFallback}>
      <ChatProvider>
        <PreventionProgramsProvider>
          <ProgressNoteFormProvider>
            <Suspense fallback={<div></div>}>
              <ChatsAvailabilityBanner />
            </Suspense>
            <ChatResizableLayout />
            <IBCNotes />
          </ProgressNoteFormProvider>
        </PreventionProgramsProvider>
      </ChatProvider>
    </ErrorBoundary>
  )
}
